import { Typography } from '@mui/material'
import { useMemo } from 'react'
import { formatTime } from '$func/date'
import { isNumber } from '$helper/functions/utils'

export function DateFormatter({ time }: { time?: number }) {
  const formattedTime = useMemo(
    () => (isNumber(time) ? formatTime(new Date(time as number)) : ''),
    [time],
  )
  return (
    <Typography
      variant="caption1"
      color="neutral500"
      className="chat-list-item--date"
    >
      {formattedTime}
    </Typography>
  )
}
